import type { QuantityControlMode } from './ProductSummarySegment.types'
import * as S from './QuantityControls.styles'

type QuantityControlsProps = {
  quantity: number
  mode: QuantityControlMode
  onIncrement: () => void
  onDecrement: () => void
  onDisabledIncrementTap?: () => void
}

function QuantityControls({
  quantity,
  mode,
  onIncrement,
  onDecrement,
  onDisabledIncrementTap,
}: QuantityControlsProps) {
  const isIncrementDisabled = mode === 'minus-only'
  return (
    <S.Container data-testid="cart-quantity-controls">
      <S.Control onClick={onDecrement} data-testid="cart-quantity-decrement">
        <S.Minus />
      </S.Control>
      <S.Count data-testid="cart-quantity-count">{quantity}</S.Count>
      <S.Control
        onClick={isIncrementDisabled ? onDisabledIncrementTap : onIncrement}
        aria-disabled={isIncrementDisabled}
        data-testid="cart-quantity-increment"
      >
        <S.Plus />
      </S.Control>
    </S.Container>
  )
}

export default QuantityControls
